import { sanitizeHtml } from '@/utils/sanitize';

const apply = (el, binding) => {
  if (binding.value !== binding.oldValue) {
    el.innerHTML = sanitizeHtml(binding.value, binding.arg);
  }
};

export default {
  bind: apply,
  update: apply,
};
